import { checkApiResponseDataEquals } from 'reactApp/api/apiHelpers';
import { PromoListAPICall } from 'reactApp/api/promo/PromoListAPICall';
import { billingDataForPromoEnabled } from 'reactApp/appHelpers/featuresHelpers/features/billingDataEndpoint';
import { updateBillingDataRequest } from 'reactApp/modules/billingData/billingData.module';
import { BillingDataPromoSelectors } from 'reactApp/modules/billingData/billingData.promo.selectors';
import { loadBillingDataIfNotLoaded } from 'reactApp/modules/billingData/billingData.provider';
import { getBillingDataLoadingState } from 'reactApp/modules/billingData/billingData.selectors';
import {
    promoTariffsStart,
    promoTariffsSuccess,
    promoTariffsUpdateStart,
    promoTariffsUpdateSuccess,
} from 'reactApp/modules/promoTariffs/promoTariffs.module';
import {
    getDiscountByProductId,
    getPromoById,
    getPromoTarifsLoadingState,
    getRawList,
    isPromoTariffsLoaded,
    sortDiscountPromoBySpace,
    sortPromoListToShow,
} from 'reactApp/modules/promoTariffs/promoTariffs.selectors';
import type { RootState } from 'reactApp/store';
import ping from 'reactApp/utils/ping';
import { call, put, select } from 'typed-redux-saga';

const promoApiCall = () => new PromoListAPICall().makeRequest();

// После 100% раскатки billingDataForPromoEnabled фолбеки заменяются по месту на непосредственный вызов билингдаты

export function* loadPromoTariffsActionFallback() {
    if (billingDataForPromoEnabled) {
        yield* loadBillingDataIfNotLoaded('promoTariffs');
        return yield* select(BillingDataPromoSelectors.getBillindDataPromoRaw);
    }
    yield* put(promoTariffsStart());
    const { data } = yield* call(promoApiCall);
    yield* put(promoTariffsSuccess({ list: data }));
    return data;
}

export function* updatePromoTariffsActionFallback({ count }: { count?: number } = {}) {
    if (billingDataForPromoEnabled) {
        yield* put(
            updateBillingDataRequest({
                showSnackbar: false,
                count,
                radar: 'promoTariffs',
                trackFields: ['promo', 'bonus', 'reward', 'android', 'huawei', 'rustore'],
            })
        );
    } else {
        yield* put(promoTariffsUpdateStart());
        const initialState = yield* select(getRawList);
        const { data } = yield* call(ping, { request: promoApiCall, check: checkApiResponseDataEquals(initialState) });
        yield* put(promoTariffsUpdateSuccess({ list: data }));
    }
}

export const PromoTariffsSelectors = {
    /**  @deprecated: учитывать, что формат разный, к использованию не рекомендуется до выпила старой ручки */
    getRawList: (!billingDataForPromoEnabled ? getRawList : BillingDataPromoSelectors.getBillindDataPromoRaw) as (
        state: RootState
    ) => unknown[],
    isPromoTariffsLoaded: !billingDataForPromoEnabled ? isPromoTariffsLoaded : (state) => getBillingDataLoadingState(state).isLoaded,
    getLoadingState: !billingDataForPromoEnabled ? getPromoTarifsLoadingState : getBillingDataLoadingState,
    getPromoById: !billingDataForPromoEnabled ? getPromoById : BillingDataPromoSelectors.getPromoById,
    sortDiscountPromoBySpace: !billingDataForPromoEnabled ? sortDiscountPromoBySpace : BillingDataPromoSelectors.sortDiscountPromoBySpace,
    getDiscountByProductId: !billingDataForPromoEnabled ? getDiscountByProductId : BillingDataPromoSelectors.getDiscountByProductId,
    sortPromoListToShow: !billingDataForPromoEnabled ? sortPromoListToShow : BillingDataPromoSelectors.sortPromoListToShow,
} as const;
